var map = {
	"./A3_tourist_posters.jpg": "fe37",
	"./Background-A3-Posters-2366x901.jpeg": "2a6d",
	"./Background-Calendars-2366x901-2021.jpeg": "cf0f7",
	"./Background-Coasters-no-text-jpg.webp": "bf11",
	"./Background-Framed-Tiles-no-text-jpg.webp": "1bc6",
	"./Background-Giclee-2366x901.jpeg": "ee6e",
	"./Background-Glass-Cutting-Boards-no-text-jpg.webp": "7508",
	"./Background-Greeting-Cards-2366x901.jpeg": "d524",
	"./Background-Magnets-2366x901.jpeg": "823d",
	"./Background-Mugs-2366x901.jpeg": "6d55",
	"./Background-Postcards-2366x901.jpeg": "5f65",
	"./Background-Small-Mounted-Prints-2366x901-.jpeg": "4f3f",
	"./Background-Stretched-Canvas-no-text-jpg.webp": "0fdd",
	"./Background-Wood-Panel-Boards-no-text-jpg.webp": "32f9",
	"./Coasters.jpg": "6ff5",
	"./Framed-Tiles.jpg": "3b63",
	"./Glass-Chopping-Boards.jpg": "592e",
	"./Stretched-Canvases---Framed.jpg": "1060",
	"./Westgate_234.jpeg": "fb1c",
	"./Wood-Panel-Boards.jpg": "8dcb",
	"./background-landing.jpg": "6f02",
	"./bg-014-green.jpg": "89f5",
	"./bg-014.jpg": "4d77",
	"./doricmor.png": "e946",
	"./doricmor_logo.jpg": "d810",
	"./doricmor_logo_2.jpg": "8c35",
	"./doricmor_logo_3.jpg": "12bd",
	"./greeting_cards.jpg": "9ab0",
	"./limited_edition_giclee.jpg": "b964",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./magnets.jpg": "e76b",
	"./mugs.jpg": "3f79",
	"./open_edition_giclee.jpg": "b238",
	"./product_hero.jpg": "fae6",
	"./small_mounted_prints.jpg": "447e",
	"./wireframes/new_artwork_promotion_email.png": "76e5",
	"./wireframes/new_artwork_promotion_email_mobile.png": "c02c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";